var offset = 25;
var last_line_offset;
var trigger_scroll = false;
function setVisible(){
	'use strict';
	
	$('.tour-section').each(function(){
		var $this 			= $(this);
		var $this_bottom 	= $this.offset().top  + $this.height();
		var $window_height 	= $(window).height();
		
		if($this_bottom <= $window_height) {
			$this.addClass('is-visible');				
		}else{
			$this.removeClass('is-visible');									
		}
		
		/*
		var strokeInit = $this.find(".section-stroke");
		var lineContainer = $this.next(".tour-stroke");
		var line = lineContainer.find(".stroke-inner");
		strokeInit.attr( 'data-offset' , strokeInit.offset().top ); 
		line.css("transform","translate3d(0px, " + (-1*line.height()) + "px, 0px)");	
		*/
	});
}

function checkVisibleSections(scroller){
	'use strict';
	
	$('.tour-section').each(function(){
		var $this 			= $(this);
		var $this_bottom 	= $this.offset().top  + $this.height();
		var $window_height 	= scroller.wrapperHeight;
				
		if (scroller.directionY > 0){
			
			/*THIS IS FOR SCROLL DOWN*/  
			if($this_bottom <= $window_height) {
				$this.addClass('is-visible');				
			}
			
			if($this_bottom <= $("header").height()){
				$this.removeClass('is-visible');									
			}
			
		} else {
		   
		   	/*THIS IS FOR SCROLL UP*/
			if($this_bottom >= $("header").height()) {
				$this.addClass('is-visible');				
			}
			
			if($this_bottom >= $window_height){
				$this.removeClass('is-visible');									
			}
		}
				
		/*if($this.hasClass("is-visible")){
			var strokeInit 		= $this.find(".section-stroke");
			var lineContainer 	= $this.next(".tour-stroke");
			var line 			= lineContainer.find(".stroke-inner");		
			var startup = (-1* Number(strokeInit.data('offset')) + line.height()/2);
			var move =  startup;
			line.css("transform","translate3d(0px, " + move + "px, 0px)");				
		}*/
		
		checkLines();	
	});	
}

function checkLines(){
	"use strict";
	if(!trigger_scroll){
		trigger_scroll = true;		
		$('.product-tour-clone .tour-stroke').each(function(){		
			var lineContainer = $(this);
			var line 	= lineContainer.find(".stroke-inner");	
			if(last_line_offset - lineContainer.offset().top >offset || last_line_offset - lineContainer.offset().top < offset){
				line.css("transform","translate3d(0px, " + -lineContainer.offset().top + "px, 0px)");		
			}
			last_line_offset = lineContainer.offset().top;   
			
		});		
		trigger_scroll = false;		
	}
}

$(function(){
	"use strict";
	checkLines();
});
